import { render, staticRenderFns } from "./Acquirers.vue?vue&type=template&id=2f79c812&scoped=true&"
import script from "./Acquirers.vue?vue&type=script&lang=js&"
export * from "./Acquirers.vue?vue&type=script&lang=js&"
import style0 from "./Acquirers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f79c812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
